import React from 'react';
import { useNavigate } from 'react-router-dom';

function AccountCreated() {
  const navigate = useNavigate();

  const handleLoginRedirect = () => {
    navigate('/login'); // Adjust path if your login page is different
  };

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      background: 'linear-gradient(to right, #00c6ff, #0072ff)',
      fontFamily: 'Segoe UI, sans-serif',
      color: '#fff',
      flexDirection: 'column',
      padding: '20px',
      textAlign: 'center',
    }}>
      <div style={{
        backgroundColor: '#ffffff20',
        padding: '40px',
        borderRadius: '16px',
        boxShadow: '0 8px 24px rgba(0,0,0,0.2)',
        maxWidth: '500px',
        width: '100%',
      }}>
        <div style={{ fontSize: '64px' }}>✅</div>
        <h1 style={{ fontSize: '32px', marginBottom: '10px' }}>Account Created!</h1>
        <p style={{ fontSize: '18px', marginBottom: '30px' }}>
          Your account has been created successfully. You can now log in and get started.
        </p>
        <button
          onClick={handleLoginRedirect}
          style={{
            padding: '12px 30px',
            fontSize: '16px',
            fontWeight: 'bold',
            backgroundColor: '#fff',
            color: '#0072ff',
            border: 'none',
            borderRadius: '8px',
            cursor: 'pointer',
            transition: '0.3s ease',
          }}
          onMouseEnter={(e) => e.target.style.backgroundColor = '#f0f0f0'}
          onMouseLeave={(e) => e.target.style.backgroundColor = '#fff'}
        >
          Go to Login
        </button>
      </div>
    </div>
  );
}

export default AccountCreated;
